import $ from 'jquery';

const $jsToggleMenu = $('.js-toggle-btn');
$jsToggleMenu.click(function (e) {
	e.preventDefault();
	$(this).toggleClass('is-active');
	$('.header__menu').fadeToggle();
	$('body').toggleClass('is-menu-open');
});
